<template>
    <div class="customer-form-management-wrap">
        <ul class="card-wrap">
            <li class="card-item" v-for="(item, index) in cardList" :key="index" @click.stop="handleClickFormSet(item)">
                <div class="card-item-title">
                    <div>
                        <img :src="item.iconUrl" :alt="item.label">
                        <span>{{ item.label }}</span>
                        <span class="switch-item" v-if="item.isSet" @dblclick.stop.prevent @click.stop.prevent>
                            <el-switch size="small" v-model="item.status" active-color="#2990FF" inactive-color="#999999" active-value="on" inactive-value="off" @change="switchChange(item)">
                            </el-switch>
                        </span>
                    </div>
                    <i class="iconfont icon-a-fenzu2"></i>
                </div>
                <p>{{ item.content }}</p>
            </li>
        </ul>
        
    </div>
</template>
<script>
import {GetCompanySwitchList, SetCompanySwitch} from "@/api";
export default {
    name: "FormManagement",
    data() {
        return {
            cardList: [
                {
                    type: "customers",
                    url: "",
                    iconUrl: "https://download.hecoos.com/enlightv/2024-44/0d0d9381f3208a4e77516a9ca866e2e9.png",
                    label: "客户信息",
                    content: "设置新增公海或私海客户时填写的信息"
                },
                {
                    type: "customer_contacts",
                    url: "",
                    iconUrl: "https://download.hecoos.com/enlightv/2024-44/0a5f397e73825eb935eb700169c3ab3b.png",
                    label: "联系人",
                    content: "设置新增客户的联系人信息"
                },
                {
                    type: "customer_follow_ups",
                    url: "",
                    iconUrl: "https://download.hecoos.com/enlightv/2024-44/455a0c458706464663a5ba9fcca244eb.png",
                    isSet: true,
                    status: "off",
                    label: "跟进记录",
                    content: "设置销售跟进客户时，不同跟进方式下填写的信息"
                },
                {
                    type: "customer_manages",
                    url: "",
                    iconUrl: "https://download.hecoos.com/enlightv/2024-44/e9c2de8c455d06beeb9065d33fef6799.png",
                    isSet: true,
                    status: "off",
                    label: "管理记录",
                    content: "设置管理人员对客户进行管理时填写的信息"
                },
            ]
        }
    },
    created() {
        this.getCompanySwitchList()
    },
    methods: {
        getCompanySwitchList() {
            GetCompanySwitchList().then(res=> {
                if(res.code === 200) {
                    const data = res.data || []
                    data.forEach(item=> {
                        const card = this.cardList.find(cardItem=> cardItem.type == item.type)
                        this.$set(card, "status", item.status)
                    })
                }
            })
        },
        handleClickFormSet(item) {
            this.$router.push({
                name: "customerFormSet",
                query: {
                    type: item.type,
                }
            })
        },
        switchChange(item) {
            SetCompanySwitch({type: item.type, status: item.status}).then(res=>{
                if(res.code === 200) {
                    this.$message.success("设置成功")
                } else {
                    this.$message.error(res.message)
                }
            })

        }
    }
}
</script>
<style lang="scss" scoped>
.customer-form-management-wrap {
    width: 100%;
    height: 100vh;
    .card-wrap {
        max-width: 1000px;
        box-sizing: content-box;
        padding: 0 173px;
        margin: 24px auto;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        gap: 24px;

        .card-item {
            width: calc(50% - 12px);
            min-width: 220px;
            max-width: 460px;
            height: 130px;
            padding: 24px 16px;
            border-radius: 6px;
            background: #FFFFFF;
            cursor: pointer;
            border: 1px solid #E8E8E8;
            &:hover {
                box-shadow: 0px 6px 16px 4px rgba(0, 0, 0, .04);
            }
            &:active {
                border-color: #2279D6;
                box-shadow: 0px 6px 16px 4px rgba(0, 0, 0, .04);
            }

            .card-item-title {
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size: 14px;
                font-weight: 700;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(51, 51, 51, 1);

                &>div {
                    height: 22px;
                    display: flex;
                    align-items: center;
                    gap: 8px;
                }

                img {
                    width: 22px;
                    height: 22px;
                }
                .iconfont {
                    color: #2990FF;
                }
            }
            .switch-item {
                display: flex;
                align-items: center;
            }

            ::v-deep {
                .el-switch__core {
                    width: 28px !important;
                    height: 16px;
                    &:after {
                                width: 12px;
                                height: 12px;
                                left: 2px;
                    }
                }
            }

            .el-switch {
                font-size: 12px;
                height: 16px;
                line-height: 16px;

                &.is-checked {
                    ::v-deep {
                        .el-switch__core {
                            &:after {
                                left: 100%;
                                margin-left: -14px;
                            }
                        }
                    }
                }
            }


            &>p {
                margin-top: 16px;
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(102, 102, 102, 1);
            }
        }
    }
}
</style>
